import { useState, useContext } from "react";
import { GlobalContext } from "./utils/GlobalContext";
import "./App.css";
import { NotificationsProvider } from "@mantine/notifications";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import PatientDashboard from "./pages/PatientDashboard";
import PatientProfile from "./pages/PatientProfile";
import DoctorDashboard from "./pages/DoctorDashboard";
import DoctorProfile from "./pages/DoctorProfile";
import EHR from "./pages/EHR";
import NotFound from "./pages/NotFound";

function App() {
  // Hooks
  const { isLoggedIn, userInfo } = useContext(GlobalContext);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div className="App">
      <Router>
        <NotificationsProvider autoClose={3500}>
          <Navbar
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
          <Routes>
            <Route
              path="/"
              element={<Home setIsDrawerOpen={setIsDrawerOpen} />}
            />
            <Route
              path="/patientdashboard"
              element={
                isLoggedIn && userInfo.userType === "patient" ? (
                  <PatientDashboard />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/patientprofile"
              element={isLoggedIn && userInfo.userType === "patient" ? <PatientProfile /> : <Navigate to="/" />}
            />
            <Route
              path="/doctordashboard"
              element={isLoggedIn && userInfo.userType === "doctor" ? <DoctorDashboard /> : <Navigate to="/" />}
            />
            <Route
              path="/doctorprofile"
              element={isLoggedIn && userInfo.userType === "doctor" ? <DoctorProfile /> : <Navigate to="/" />}
            />
            <Route
              path="/ehr"
              element={isLoggedIn && userInfo.userType === "doctor" ? <EHR /> : <Navigate to="/" />}
            />
            {/* 404 Not Found */}
            <Route path="*" exact={true} element={<NotFound />} />
          </Routes>
        </NotificationsProvider>
      </Router>
    </div>
  );
}

export default App;
